import PropTypes from 'prop-types'

import { CardEditButton, CardFrame, CardHeader, CardTitle } from './ProfileStyle'

/**
 * Card frame shared by every section of the profile page. The edit action sits
 * beside the heading on desktop and becomes a full-width button at the bottom
 * of the card on mobile.
 */
const ProfileCard = ({ title, handleEdit, editLabel = 'Edit', headerAction, id, children }) => (
  <CardFrame id={id}>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
      {headerAction ??
        (!!handleEdit && (
          <CardEditButton type='button' onClick={handleEdit}>
            {editLabel}
          </CardEditButton>
        ))}
    </CardHeader>
    <div>{children}</div>
  </CardFrame>
)

ProfileCard.propTypes = {
  title: PropTypes.string.isRequired,
  handleEdit: PropTypes.func,
  editLabel: PropTypes.string,
  headerAction: PropTypes.node,
  id: PropTypes.string,
  children: PropTypes.node,
}

export default ProfileCard
